/**
 * Andi for Business feature flag (design 01 section 7, ORGS_ENABLED).
 *
 * The backend gives the frontend no flag endpoint, so visibility is a build time
 * variable, `VITE_ORGS_ENABLED=true`, off when unset. A second, runtime switch lives in
 * the workspace store: a `404 not_enabled` from `GET /api/v1/orgs` turns the whole
 * feature off for the session. With either one off a user sees no change anywhere.
 *
 * It is a function (not a module constant) so tests can stub the variable per test;
 * Vite still replaces `import.meta.env.VITE_ORGS_ENABLED` statically in a build.
 */
export function isOrgsEnabled(): boolean {
  return import.meta.env.VITE_ORGS_ENABLED === 'true';
}
